module.exports = __webpack_public_path__ + "static/img/left-home-row-3.95d703c8.webp";